import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useRegisterReasonRefusal() {
  const [loading, setLoading] = useState(false);

  async function execute(
    reason: string,
    description: string,
    callback?: () => void,
  ) {
    try {
      setLoading(true);
      const response = await api.post('v1/backoffice/reasons-refusal', {
        reason,
        description,
      });

      if (response.status === 201) {
        toast.success(
          ToastMessages.reasonRefusal.success.registerReasonRefusal,
        );
        if (callback) {
          callback();
        }
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.reasonRefusal.error.registerReasonRefusal);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
